import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-role-form" }
const _hoisted_2 = {
  key: 0,
  class: "loading apollo"
}

import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { useMutation } from "@vue/apollo-composable";
import { logErrorMessages } from "@vue/apollo-util";

import Modal from "@/components/Modal.vue";
import FormItem from "@/components/form/FormItem.vue";
import BasicButton from "@/components/BasicButton.vue";

import { UPDATE_DEFAULT_ROLE } from "@/graphql/defaultRole/mutations";
import { GET_DEFAULT_ROLES } from "@/graphql/defaultRole/queries";

import enUK from "@/locales/en-UK.json";

interface DefaultRole {
  id: string;
  name: string;
  hourlyRate: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditRoles',
  props: {
  role: {
    type: Object as () => DefaultRole,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const toast = useToast();

// Initialize form with the role data
const editRoleName = ref(props.role.name);
const editRoleHourlyRate = ref<number | string>(props.role.hourlyRate / 100);
const editRoleId = ref(props.role.id);

const {
  mutate: updateRole,
  onError: onUpdateRoleError,
  onDone: onUpdateRoleDone,
  loading: updatingRole,
} = useMutation(UPDATE_DEFAULT_ROLE, {
  refetchQueries: [{ query: GET_DEFAULT_ROLES }],
});

onUpdateRoleError((error) => {
  logErrorMessages(error);
  toast.error(t("errors.updateDefaultRole"));
});

onUpdateRoleDone(() => {
  toast.success(t("success.updateDefaultRole"));
  emit("close");
});

const isLoading = computed(() => updatingRole.value);

async function handleUpdateRole(): Promise<void> {
  if (!editRoleName.value || !editRoleHourlyRate.value) {
    toast.error(t("errors.requiredFields"));
    return;
  }

  const hourlyRateInCents =
    typeof editRoleHourlyRate.value === "string"
      ? Math.round(parseFloat(editRoleHourlyRate.value) * 100)
      : editRoleHourlyRate.value;

  if (isNaN(hourlyRateInCents)) {
    toast.error(t("errors.invalidHourlyRate"));
    return;
  }

  await updateRole({
    id: editRoleId.value,
    name: editRoleName.value,
    hourlyRate: hourlyRateInCents,
  });
}

function closeModal(): void {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { onClose: closeModal }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("titles.role.edit")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormItem, {
          input: editRoleName.value,
          "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((editRoleName).value = $event)),
          label: _unref(t)('labels.name'),
          name: "name",
          "input-type": "basic"
        }, null, 8, ["input", "label"]),
        _createVNode(FormItem, {
          input: editRoleHourlyRate.value,
          "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((editRoleHourlyRate).value = $event)),
          label: _unref(t)('labels.hourlyRate'),
          name: "hourlyRate",
          "input-type": "basic"
        }, null, 8, ["input", "label"])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(BasicButton, {
        class: "edit-button",
        type: "submit",
        disabled: isLoading.value,
        onClick: handleUpdateRole
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.save")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(BasicButton, {
        class: "cancel-button",
        onClick: closeModal
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.cancel")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})